import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { pagination_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { header } from "./header";
import { contentModerationList_template } from "../components/templates/contentModerationList_template";

declare var ko: any;
declare var page: any;

export class contentModeration extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected template: contentModerationList_template;
    protected pagination: pagination_template;

    protected getModuleName(){

        return "contentModeration";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        this.template = new contentModerationList_template("list", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Content Moderation");

        return [this.template.build()];
    }
    public fillPage() : void{

        this.getReferences();
        this.template.buildDatePickerCalendar();
    }

    protected getReferences() {

        // LOADING : starts
        this.loadingIn(this.template.builtTemplate);

        let usrReq_url: string = '/api/website-users/content-moderation/references';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['getReferences'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getReferences'].onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdls['getReferences'].execute();
    }

    public onReferencesRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.template.setBrands(responseParsed.brands);
                obj.template.setContentStatusOptions(responseParsed.status);
                obj.template.setIsManuallyModeratedOptions(responseParsed.isManuallyModeratedOptions);
                obj.template.setBulkActions(responseParsed.bulkActions);

                //set filters
                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();

                obj.loadingOut(obj.template.builtTemplate);
            })
        }
    }

    // preset filter methods
    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.template.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onSaveSearchPresetReturn;
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onSaveSearchPresetReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.template.addCreatedPresetToList(response);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onSaveFavoriteSearchPresetReturn
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onSaveFavoriteSearchPresetReturn(req, obj): Function {

        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
            });
        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            // @ts-ignore
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.template.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.template.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected setDefaultStatusFilters(){

        this.template.setDefaults();
    }

    protected filterByUrl(){

        this.updateViewModelFromPath();
        this.filterList();
    }

    protected viewArticleOnSite(permalink, domain){

        let origin = document.location.origin;
        let brandDomain = domain;
        if(!origin.includes("https://emakicms.com")){
            brandDomain = brandDomain.replace("www.","");
        }
        let url = origin.replace("emakicms.com", brandDomain) + permalink;

        if(url.includes("mig1")){
            url = url.replace("mig1", "qa4");
        }

        if(url.includes("mig3")){
            url = url.replace("mig3", "qa3");
        }

        if(url.includes("mig4")){
            url = url.replace("mig4", "qa1");
        }
        if(url.includes("mig2")){
            url = url.replace("mig2", "qa8");
        }

        window.open(url,'_blank');
    }

    protected viewTagOnSite(permalink, domain){
        let origin = document.location.origin;
        const devEnvMatch = origin.match(/\.com(.*)/);

        let devEnv = "";
        if(devEnvMatch) {
            devEnv = devEnvMatch[1];
        }

        const envMapping = {
            mig1: 'qa4',
            mig3: 'qa3',
            mig4: 'qa1',
            mig2: 'qa8'
        };

        let regexp = Object.keys(envMapping).join('|');

        let url = domain.replace(new RegExp(regexp), match => envMapping[match]).replace(".com", `.com${devEnv}`);
        if(!url.startsWith("https://")){
            url = "https://" + url;
        }
        url += permalink;

        window.open(url,'_blank');
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.template.builtTemplate.children.namedItem("list-results"));
        this.template.setSelectAllChecked(false);

        let usrReq_url: string = `/api/website-users/content-moderation/get/`;
        let subViewModel = this.template.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'website-users-comments');
        this.updateViewModelFromPath(); //to set selected filters
    }

    protected paginationOnPageClick(){
        this.filterList();
    }

    protected filterDropdownOnChange(idElement){

        switch(idElement){
            case "bulkAction":
                break;
            case "viewModeFilter":
                this.viewModel.list.pagination.pageNumber(1);
                this.template.setContentModerationList([]);
                this.filterList();
                break;
            default:
                this.viewModel.list.pagination.pageNumber(1);
                this.filterList();
        }

    }

    protected filterSimpleOnChange(idElement){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDateOnChange(){

        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected contentModerationListReorder(){

        this.filterList();
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.paginatedResults, req.requestStartTime);
            });
            obj.loadingOut(obj.template.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(paginatedResults: any, requestStartTime){
        this.template.setContentModerationList(paginatedResults.data);

        const execTime = Math.round((new Date().getTime() - requestStartTime) / 1000 * 100) / 100;
        this.template.setResultInfo(paginatedResults.totalCount, paginatedResults.totalPage, execTime);

        // update the paginator
        this.viewModel.list.pagination.itemCount(paginatedResults.totalCount);
        this.template.updateBulkActions();
    }

    protected updateModeratedContents(): void {

        const bulkActions = {
            "-1": 'delete',
            2: 'approve',
            3: 'reject',
        }

        let usrReq_url: string = `/api/website-users/content-moderation/${bulkActions[this.template.getSelectedBulkAction()]}/`;
        let subViewModel = this.template.getViewModelForUpdate();

        this.sendFilterCall(usrReq_url, subViewModel, this.onUpdateContentReturn, XMLHttpRequestHandler_requestType.POST, 'updateModeratedContents', null, false);
    }

    protected onUpdateContentReturn(req, obj): Function {
        return () => {
            obj.manageResponse(req, obj, function () {
                if(req.request.status == 200) {
                    obj.template.setSelectAllChecked(false);
                    const idContents = JSON.parse(req.request.response);
                    if(idContents) {
                        obj.replaceModeratedContent(idContents);
                    }
                }
            });
        }
    }


    protected getMemoryViewModel(){
        let templateViewModel = this.template.getTemplateViewModel();

        delete templateViewModel.tags;

        return templateViewModel;
    }

    protected approveContent(content): void {
        if(content && content.id) {
            // LOADING : starts
            // this.loadingIn(this.template.builtTemplate.children.namedItem("list-results"));

            let usrReq_url: string = `/api/website-users/content-moderation/approve/`;
            let subViewModel = {
                idContents: [content.id],
                viewMode: this.template.getViewMode(),
            };

            this.sendFilterCall(usrReq_url, subViewModel, this.onContentModerationReturn, XMLHttpRequestHandler_requestType.POST, 'approveContent', null, false);
        }
    }

    protected rejectContent(content): void {
        if(content && content.id) {
            // LOADING : starts
            // this.loadingIn(this.template.builtTemplate.children.namedItem("list-results"));

            let usrReq_url: string = `/api/website-users/content-moderation/reject/`;
            let subViewModel = {
                idContents: [content.id],
                viewMode: this.template.getViewMode(),
            };

            this.sendFilterCall(usrReq_url, subViewModel, this.onContentModerationReturn, XMLHttpRequestHandler_requestType.POST, 'rejectContent', null, false);
        }
    }

    protected moderateUser(user, type): void {
        if(user && user.idWebsiteUser) {
            let usrReq_url: string;
            switch(type) {
                case 'spam':
                    usrReq_url = `/api/website-users/content-moderation/users/set-website-user-is-spammer/${user.idWebsiteUser}`;
                    break;
                case 'cancel':
                    usrReq_url = `/api/website-users/content-moderation/users/cancel-website-user/${user.idWebsiteUser}`;
                    break;
                default:
                    return;
            }

            this.sendFilterCall(usrReq_url, {viewMode: this.template.getViewMode(),"idComment": user.id, "commentText": user.commentText, "brandShortName" : user.brandShortName}, this.onContentModerationReturn, XMLHttpRequestHandler_requestType.POST, 'setSpammer', null, false);
        }
    }

    protected onContentModerationReturn(req, obj): Function {
        return () => {
            obj.manageResponse(req, obj, function () {
                if(req.request.status == 200) {
                    const idContents = JSON.parse(req.request.response);
                    if(idContents) {
                        obj.replaceModeratedContent(idContents);
                    }
                }
            });
        }
    }

    protected replaceModeratedContent(idContents): void {
        this.template.removeRows(idContents);
    }
}


// WEBPACK FOOTER //
// ./js/modules/contentModeration.ts